import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {ArtistCollectionComponent} from './component/artist-collection/artist-collection.component';
import {ArtistComponent} from './component/artist/artist.component';
import {AlbumComponent} from './component/album/album.component';
import {AlbumsForArtistComponent} from './component/albums-for-artist/albums-for-artist.component';
import {AllArtistsComponent} from './component/all-artists/all-artists.component';
import { AlbumCollectionComponent } from './component/album-collection/album-collection.component';

const routes: Routes = [
  { path: '', redirectTo: '/artistCollection', pathMatch: 'full' },
  { path: 'artistCollection', component: ArtistCollectionComponent },
  { path: 'albumCollection', component: AlbumCollectionComponent },
  { path: 'artist', component: AllArtistsComponent,
    children: [
      {path: '', redirectTo: '/collection', pathMatch: 'full'},
      {path: ':artistId', component: ArtistComponent }
    ]},
  { path: 'artist/:artistId', component: ArtistComponent },
  { path: 'artist/:artistId/album', component: AlbumsForArtistComponent,
    children: [
      {path: '', redirectTo: '/collection', pathMatch: 'full'},
      {path: ':albumId', component: AlbumComponent }
    ]},
    { path: '**', redirectTo: '/artistCollection' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {scrollPositionRestoration: 'enabled'}) ],
  exports: [ RouterModule ]
})
export class AppRoutingModule {}
